
/**
* Polyfill for parents method
* @param {*} selector
*/
function parents(selector) {
  const elements = [];
  let elem = this;
  const isHaveSelector = selector !== undefined;

      while ((elem = elem.parentElement) !== null) { //eslint-disable-line
    if (elem && elem.nodeType !== window.Node.ELEMENT_NODE) {
        continue; //eslint-disable-line
    }

    if (!isHaveSelector || (elem && elem.matches(selector))) {
      elements.push(elem);
    }
  }

  return elements;
}

window.Element.prototype.parents = parents;

/**
  * helper method to get siblings
  * @param {*} selector
  */

const getSiblings = (e) => {
  const siblings = [];

  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }

  // first child of the parent node
  let sibling = e.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};

function stickyHeader() {
  const header = document.querySelector('.header');
  const scrolledEnough = document.body.scrollTop > 70 || document.documentElement.scrollTop > 70;
  const scrolledEnoughWithBg = document.body.scrollTop > 500
  || document.documentElement.scrollTop > 500;
  if (document.getElementById('bgImg')) {
    return scrolledEnoughWithBg ? header.classList.add('white') : header.classList.remove('white');
  }
  return scrolledEnough ? header.classList.add('white') : header.classList.remove('white');
}

function toggleOtherSiblings(currentElement, activeClass) {
  // eslint-disable-next-line max-len
  // const existingActiveElements = document.querySelectorAll(`.${parentElement.classList[0]} .${classToAdd}`);
  // existingActiveElements.forEach(activeElement => activeElement.classList.remove(classToAdd));
  const siblings = getSiblings(currentElement);
  siblings.forEach(sibling => sibling.classList.remove(activeClass));
}

function accordionUIHandler(event, stopAtParent, activeClass) {
  const currentElement = event.target.parents(stopAtParent)[0];
  if (currentElement.classList.contains(activeClass)) {
    currentElement.classList.remove(activeClass);
    // toggleOtherSiblings(currentElement, activeClass);
  } else {
    toggleOtherSiblings(currentElement, activeClass);
    currentElement.classList.add(activeClass);
  }
}

function headerScripts() {
  const mainDropDowns = document.querySelectorAll('.desktop-only.has-menu');
  const navigationToggleBtn = document.querySelector('.navigation-toggle button');

  mainDropDowns.forEach((mainDropdown) => {
    mainDropdown.addEventListener('mouseover', (event) => {
      event.target.parents('.has-menu')[0].classList.add('show-drop');
    });
    mainDropdown.addEventListener('mouseout', (event) => {
      event.target.parents('.has-menu')[0].classList.remove('show-drop');
    });
  });
  if (navigationToggleBtn) {
    navigationToggleBtn.addEventListener('click', (event) => {
      event.target.parents('.header')[0].classList.toggle('navigation-toggled');
      event.target.parents('.webpage')[0].classList.toggle('no-scroll');
      document.body.classList.toggle('no-scroll');
    });
  }
  stickyHeader();
}

window.addEventListener('load', () => {
  headerScripts();

  const accordionItems = document.querySelectorAll('.accordion-item .panel-header');
  accordionItems.forEach((accordionItem) => {
    accordionItem.addEventListener('click', (event) => {
      accordionUIHandler(event, '.accordion-item', 'active');
    });
  });
  const solodropdowns = document.querySelectorAll('.accordion-item .solo-header');
  solodropdowns.forEach((solodropdown) => {
    solodropdown.addEventListener('click', (event) => {
      event.target.closest('.accordion-item').classList.toggle('active');
    });
  });
});

window.addEventListener('scroll', () => {
  stickyHeader();
});
